import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule
  ],
  template: `
    <div class="flex items-center justify-center" [ngClass]="containerClass">
      <div class="text-center">
        <p-progressSpinner 
          [strokeWidth]="strokeWidth"
          [style]="{ 'width': size, 'height': size }"
          animationDuration="1s">
        </p-progressSpinner>
        @if (message) {
          <p class="text-body-md text-secondary mt-4">{{ message }}</p>
        }
      </div>
    </div>
  `
})
export class LoadingSpinnerComponent {
  @Input() size: string = '3rem';
  @Input() strokeWidth: string = '2';
  @Input() message?: string;
  @Input() containerClass: string = 'py-12';
}